const DatoCmsPlugin = require('datocms-plugins-sdk');

import './style.scss';


DatoCmsPlugin.init(async (plugin) => {
	const wrapper = document.createElement('div');
	wrapper.classList.add('wrapper');

	const sitemapXML = await fetch(plugin.parameters.global.sitemapUrl)
					.then(response => response.text())
					.then(data => {
						const parser = new DOMParser();
						const xml = parser.parseFromString(data, "application/xml");

						return xml;
					});

	const stories = Array.from(sitemapXML.getElementsByTagName('loc')).map(u => u.textContent);

	stories.forEach((slug) => {
		const link = document.createElement('button');

		link.classList.add('item');

		link.textContent = slug;

		link.onclick = function(e) {
			plugin.setFieldValue(plugin.fieldPath, e.target.innerHTML);
		}

		wrapper.appendChild(link);
	});

	document.body.appendChild(wrapper);

	plugin.startAutoResizer();
});
